const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "heic",
  "heif",
  "tif",
  "tiff",
  "svg",
]);

const HEIC_EXTENSIONS = new Set(["heic", "heif"]);

function normalizeExtension(extension?: string | null): string {
  return (extension || "").replace(/^\./, "").toLowerCase();
}

function extensionFromPath(path?: string | null): string {
  if (!path) {
    return "";
  }
  const base = path.split(/[?#]/)[0].toLowerCase();
  const match = base.match(/\.([a-z0-9]+)$/i);
  return match?.[1] || "";
}

export function resolveDocumentImageExtension(
  extension?: string | null,
  name?: string | null,
  fileName?: string | null,
  url?: string | null
): string {
  const normalizedExtension = normalizeExtension(extension);
  if (normalizedExtension) {
    return normalizedExtension;
  }
  return (
    extensionFromPath(name) ||
    extensionFromPath(fileName) ||
    extensionFromPath(url)
  );
}

export function isHeicDocumentExtension(extension: string): boolean {
  return HEIC_EXTENSIONS.has(normalizeExtension(extension));
}

export function isPreviewableDocumentImage(
  extension?: string | null,
  name?: string | null,
  fileName?: string | null,
  url?: string | null
): boolean {
  const resolvedExtension = resolveDocumentImageExtension(
    extension,
    name,
    fileName,
    url
  );
  if (resolvedExtension === "pdf") {
    return false;
  }
  if (resolvedExtension && IMAGE_EXTENSIONS.has(resolvedExtension)) {
    return true;
  }

  const urlLower = (url || "").toLowerCase();
  return [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg", ".tiff", ".tif", "image/"].some(
    (token) => urlLower.includes(token)
  );
}
